import { Component, EventEmitter, inject, OnInit } from '@angular/core';
import { HasCloseEvent } from '../../../interfaces/has-close-event.interface';
import { SvgIconComponent } from '../../svg-icon/svg-icon.component';
import { SettingOption } from '../../../interfaces/settings-option.interface';
import { SettingsService } from '../../../services/settings.service';
import { FancyButtonComponent } from '../../fancy-button/fancy-button.component';
import { NgClass } from '@angular/common';
import { ButtonType } from '../../fancy-button/button-type.enum';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-settings-popup',
  standalone: true,
  imports: [
    SvgIconComponent,
    FancyButtonComponent,
    NgClass,
    TranslocoDirective
  ],
  templateUrl: './settings-popup.component.html',
  styleUrl: './settings-popup.component.scss'
})
export class SettingsPopupComponent<T> implements OnInit, HasCloseEvent {
  public data: SettingOption<T> = {} as SettingOption<T>;
  public closeEvent: EventEmitter<boolean> = new EventEmitter<boolean>()

  protected settingOption: SettingOption<T> = {} as SettingOption<T>;
  protected readonly buttonType = ButtonType;

  private settingsService = inject(SettingsService);

  ngOnInit() {
    this.settingOption = this.data;
  }

  protected setValue(value: { value: T; label: string }) {
    this.settingsService.updateSetting(value.value, this.settingOption);
  }

  protected isFontSetting(): boolean {
    return this.settingsService.isFontSetting(this.settingOption);
  }

  protected isLanguageSetting(): boolean {
    return this.settingsService.isLanguageSetting(this.settingOption);
  }
}
